module.exports = __webpack_public_path__ + "img/Z61Q_05.a573c4d2.jpg";